import {
  MAT_DATE_FNS_FORMATS,
  provideDateFnsAdapter as matProvideDateFnsAdapter,
} from '@angular/material-date-fns-adapter';
import type { Provider } from '@angular/core';

type DateInputFormat = 'P  HH:mm' | 'P';

export function provideCustomDateFnsAdapter(
  dateInputFormat: DateInputFormat = 'P  HH:mm',
): Provider[] {
  return matProvideDateFnsAdapter({
    ...MAT_DATE_FNS_FORMATS,
    display: {
      ...MAT_DATE_FNS_FORMATS.display,
      dateInput: dateInputFormat,
    },
  });
}
